var map = {
	"./bg-vector.png": 20515,
	"./camera.svg": 15632,
	"./error-icon.svg": 86440,
	"./faq.png": 20573,
	"./forgot.png": 98894,
	"./heart-result.svg": 92727,
	"./heart.svg": 87730,
	"./icon-1.png": 50672,
	"./icon-2.png": 29102,
	"./icon-3.png": 76713,
	"./icon-4.png": 42594,
	"./landing-bg.png": 66474,
	"./landing-image.png": 93107,
	"./logo-title.svg": 20206,
	"./logo.png": 74427,
	"./logo.svg": 82835,
	"./mark.svg": 54661,
	"./mask.svg": 33372,
	"./note-icon.svg": 52098,
	"./oxygen-result.svg": 24427,
	"./oxygen.svg": 10233,
	"./points.svg": 63892,
	"./pressure-result.svg": 14678,
	"./pressure.svg": 15131,
	"./resp-rate-result.svg": 37740,
	"./resp-rate.svg": 43985,
	"./result-mark.svg": 2554,
	"./sdnn-result.svg": 55263,
	"./sdnn.svg": 7433,
	"./sex-female.svg": 76515,
	"./sex-male.svg": 77698,
	"./start-button.svg": 76025,
	"./stress-result.svg": 63472,
	"./stress.svg": 65566,
	"./vid.png": 77329,
	"./vsm-logo.png": 87522,
	"./warning-icon.svg": 27024,
	"./warning.svg": 64370,
	"./whiteBg.png": 59600
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;